import React from 'react';
import { FolderOutlined, RightOutlined } from '@ant-design/icons';
import { Checkbox, Space, Tooltip } from 'antd';
import { Maybe } from 'graphql/jsutils/Maybe';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

import { AutoTooltip } from '../entity/shared/components/common/AutoTooltip';
import { useTranslation } from '../../i18n/useTranslation';
import { useEntityRegistry } from '../useEntityRegistry';
import { ANTD_GRAY } from '../entity/shared/constants';
import { EntityType } from '../../types.generated';

const ItemWrapper = styled.div`
    transition: 0.15s;
`;

const GlossaryItem = styled.div`
    align-items: center;
    border-bottom: 1px solid ${ANTD_GRAY[4]};
    color: #262626;
    display: flex;
    font-size: 14px;
    font-weight: 700;
    justify-content: space-between;
    line-height: 22px;
    padding: 16px 24px;

    > span {
        display: flex;
        align-items: center;
    }

    .anticon-folder {
        margin-right: 8px;
    }
`;

const StyledRightOutline = styled(RightOutlined)`
    color: ${ANTD_GRAY[7]};
    font-size: 14px;
    margin-right: 20px;
`;

const CountWrapper = styled.span``;

const GlossaryName = styled.div`
    max-width: 600px;
    word-break: break-word;
`;

interface Props {
    urn: string;
    name: string;
    type: EntityType;
    canExport?: boolean;
    canDelete?: boolean;
    count?: Maybe<number>;
    selectedItems?: string[];
    handleItemCheck: (event, name) => void;
}

function GlossaryEntityItem(props: Props) {
    const { t } = useTranslation();
    const { name, urn, type, count, selectedItems, canExport, canDelete, handleItemCheck } = props;

    const entityRegistry = useEntityRegistry();

    return (
        <Link to={`${entityRegistry.getEntityUrl(type, urn)}`}>
            <ItemWrapper>
                <GlossaryItem className="f-glossary-list-item">
                    <Space size="middle" align="center" className="pr-4">
                        <Tooltip
                            title={!canDelete && !canExport ? t('UNAUTHORISED_TOOLTIP') : undefined}
                            overlayClassName="f-tooltip-white"
                        >
                            <Checkbox
                                checked={selectedItems?.includes(urn)}
                                onClick={(event) => handleItemCheck(event, name)}
                                aria-label={`Select ${name}`}
                                disabled={!canDelete && !canExport}
                            />
                        </Tooltip>

                        {type === EntityType.GlossaryNode && <FolderOutlined className="f-color-blue-s100" />}
                        <GlossaryName className="f-text-medium-content f-text-semibold f-color-dark-black-s100">
                            <AutoTooltip>{name}</AutoTooltip>
                        </GlossaryName>
                        <CountWrapper className="f-text-content f-text-normal f-color-dark-black-s70 pl-2">
                            {count}
                        </CountWrapper>
                    </Space>
                    {type === EntityType.GlossaryNode && <StyledRightOutline />}
                </GlossaryItem>
            </ItemWrapper>
        </Link>
    );
}

export default GlossaryEntityItem;
